import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/home/Page";

export const PATH = "/vendors";

function Home() {
	return (
		<>
			<NskHead title="ダッシュボード" />
			<Component />
		</>
	);
}

export default Home;
